export const roundedTopRectPath = (x, y, width, height, radius) => {
  const r = Math.min(radius, height, width / 2);
  return `M${x},${y + height} V${y + r} Q${x},${y} ${x + r},${y} H${x + width - r} Q${x + width},${y} ${x + width},${y + r} V${y + height} Z`;
};

export const formatTick = (value) => {
  if (value >= 1000000) return `${(value / 1000000).toFixed(1).replace(/\.0$/, "")}M`;
  if (value >= 1000) return `${(value / 1000).toFixed(1).replace(/\.0$/, "")}k`;
  return String(value);
};

const NICE_STEPS = [1, 1.5, 2, 2.5, 3, 4, 5, 6, 8, 10];

// Step size that splits [0, value] into 4 "nice" intervals (1 / 1.5 / 2 / 2.5 / ... × 10^n).
export const niceTickStep = (value) => {
  if (value <= 0) return 1;
  const rawStep = value / 4;
  const power = Math.pow(10, Math.floor(Math.log10(rawStep)));
  const nice = NICE_STEPS.find((n) => n >= (rawStep / power) - 1e-9) ?? 10;
  return Math.max(1, Math.round(nice * power));
};
